export default "__VITE_ASSET__v__bL5yL__"